import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import FormattedNumber from '../../../../../FormattedNumber'
import Currency from '../../../../../Currency'

import { LOCALE_PREFIX } from '../../constants'
import './style.scss'

export default class DataTable extends Component {
    static propTypes = {
        data: PropTypes.array,
    }

    render() {
        const { data } = this.props

        return (
            <div className={'sbg-data-table'}>
                <table>
                    <thead>
                        <tr>
                            <th>
                                <span>
                                    <FormattedMessage id={`${LOCALE_PREFIX}.thName`} />
                                </span>
                            </th>
                            <th>
                                <span>
                                    <FormattedMessage id={`${LOCALE_PREFIX}.thValue`} />
                                    <Currency currency={data?.[0]?.amount?.currency} />
                                    {')'}
                                </span>
                            </th>
                            <th>
                                <span>
                                    <FormattedMessage id={`${LOCALE_PREFIX}.thShare`} />
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {_.map(data, (row, rowIndex) => (
                            <tr key={`sbg-data-table-row-${rowIndex}`}>
                                <td>
                                    <span>{row?.title || ''}</span>
                                </td>
                                <td>
                                    <span>
                                        <FormattedNumber
                                            value={row?.amount?.amount || 0}
                                            currency={row?.amount?.currency}
                                            displayCurrency={false}
                                            displayUnits={false}
                                            displayNegativesRed
                                            customBase={1000}
                                            decimalPlaces={0}
                                        />
                                    </span>
                                </td>
                                <td>
                                    <span>{`${Number.parseFloat(_.get(row, 'percentage', '-')).toFixed(2)}`}</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}
